import { default as _91_46_46_46page_934vMAGF7AJQMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/[...page].vue?macro=true";
import { default as account_45loginHeBo1GymY4Meta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/account-login.vue?macro=true";
import { default as _91slug_931Qxu5wE6NbMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/account/[slug].vue?macro=true";
import { default as _91id_935uyfQGqfNmMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/account/holidays/[id].vue?macro=true";
import { default as _91id_93HUC0WTeB3oMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/account/holidays/payments/[id].vue?macro=true";
import { default as indexEbuUNXQpSjMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/account/index.vue?macro=true";
import { default as confirmationUOKZO2s1zvMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/booking/confirmation.vue?macro=true";
import { default as processingEFVPDnTlxsMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/booking/processing.vue?macro=true";
import { default as _91id_93zOUSkpLaKUMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/booking/step/[id].vue?macro=true";
import { default as _91_46_46_46post_93ff6TbDJlFyMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/events/[...post].vue?macro=true";
import { default as indexrkAqtQKxTcMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/events/index.vue?macro=true";
import { default as _91number_93GVBV784GRNMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/events/page/[number].vue?macro=true";
import { default as _91_46_46_46page_93Rl5CDfmslWMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/homes-for-sale/[...page].vue?macro=true";
import { default as loginlpSf2qbfrcMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/login.vue?macro=true";
import { default as _91_46_46_46post_93b9NEiO1CcvMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/news/[...post].vue?macro=true";
import { default as _91slug_93KeqJLNbTiaMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/news/category/[slug].vue?macro=true";
import { default as indexD2rlGiWTAcMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/news/index.vue?macro=true";
import { default as _91number_93MY6yg68XCBMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/news/page/[number].vue?macro=true";
import { default as otpp6hfDPbWkYMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/otp.vue?macro=true";
import { default as password_45reset7fvGMNSe8xMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/password-reset.vue?macro=true";
import { default as register48R96BR8z2Meta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/register.vue?macro=true";
import { default as search_45calendarEY356Esm6xMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/search-calendar.vue?macro=true";
import { default as results0NAGY0vRnJMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/search/results.vue?macro=true";
import { default as sitemapzCHIR4T6oGMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/sitemap.vue?macro=true";
import { default as style_45guiderZTsTyeJ9uMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/style-guide.vue?macro=true";
import { default as update_45passwordsNuMYynDACMeta } from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/update-password.vue?macro=true";
export default [
  {
    name: "page",
    path: "/:page(.*)*",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/[...page].vue")
  },
  {
    name: "account-login",
    path: "/account-login",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/account-login.vue")
  },
  {
    name: "account-slug",
    path: "/account/:slug()",
    meta: _91slug_931Qxu5wE6NbMeta || {},
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/account/[slug].vue")
  },
  {
    name: "account-holidays-id",
    path: "/account/holidays/:id()",
    meta: _91id_935uyfQGqfNmMeta || {},
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/account/holidays/[id].vue")
  },
  {
    name: "account-holidays-payments-id",
    path: "/account/holidays/payments/:id()",
    meta: _91id_93HUC0WTeB3oMeta || {},
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/account/holidays/payments/[id].vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexEbuUNXQpSjMeta || {},
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/account/index.vue")
  },
  {
    name: "booking-confirmation",
    path: "/booking/confirmation",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/booking/confirmation.vue")
  },
  {
    name: "booking-processing",
    path: "/booking/processing",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/booking/processing.vue")
  },
  {
    name: "booking-step-id",
    path: "/booking/step/:id()",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/booking/step/[id].vue")
  },
  {
    name: "events-post",
    path: "/events/:post(.*)*",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/events/[...post].vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/events/index.vue")
  },
  {
    name: "events-page-number",
    path: "/events/page/:number()",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/events/page/[number].vue")
  },
  {
    name: "homes-for-sale-page",
    path: "/homes-for-sale/:page(.*)*",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/homes-for-sale/[...page].vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/login.vue")
  },
  {
    name: "news-post",
    path: "/news/:post(.*)*",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/news/[...post].vue")
  },
  {
    name: "news-category-slug",
    path: "/news/category/:slug()",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/news/category/[slug].vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/news/index.vue")
  },
  {
    name: "news-page-number",
    path: "/news/page/:number()",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/news/page/[number].vue")
  },
  {
    name: "otp",
    path: "/otp",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/otp.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/password-reset.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/register.vue")
  },
  {
    name: "search-calendar",
    path: "/search-calendar",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/search-calendar.vue")
  },
  {
    name: "search-results",
    path: "/search/results",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/search/results.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/sitemap.vue")
  },
  {
    name: "style-guide",
    path: "/style-guide",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/style-guide.vue")
  },
  {
    name: "update-password",
    path: "/update-password",
    component: () => import("/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/pages/update-password.vue")
  }
]